module.exports = __webpack_public_path__ + "f88988d3df3d1497be33234e1efa7ace.svg";